import { combineReducers } from 'redux'
import { authentication } from './authentication/reducers'
import { invoices } from './invoices/reducers'
import { contact } from './contact/reducers'
import { bank } from './bank/reducers'
import { rodo } from './rodo/reducers'
import { DESTROY_SESSION } from './global/actions'

const appReducer = combineReducers({
  invoices,
  authentication,
  contact,
  bank,
  rodo
})

const rootReducer = (state, action) => {
  if(action.type === DESTROY_SESSION) state = undefined;
  return appReducer(state, action);
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/store/index.js